import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A layout component that arranges its children in a vertical stack.
 *
 * @remarks
 * This component applies the 'stack' CSS class to create a vertical layout container
 * where all children occupy the same space using CSS Grid. By default, all children
 * have opacity: 0. To make a child visible, add the className 'show' or 'showDelayed'.
 *
 * Children visibility classes:
 * - 'show': Makes the child visible with opacity: 1 and a 0.2s transition
 * - 'showDelayed': Makes the child visible with opacity: 1 and a 0.2s delay before transitioning
 *
 * The styling behavior is defined in the accompanying Stack.css file.
 *
 * @param props - The component props
 * @param props.children - The child elements to be arranged in a vertical stack
 *
 * @example
 * ```tsx
 * <Stack>
 *   <Spinner spinning={isLoading} className={isLoading ? 'show' : ''} />
 *   <span className={isDone ? 'showDelayed' : ''}>✓</span>
 * </Stack>
 * ```
 *
 * @returns A div element containing the stacked children
 */
import './Stack.css';
export const Stack = ({ children }) => {
    return _jsx("div", { className: 'stack', children: children });
};
